import { Workbook } from "../types/Storyboard";
import { CONFIG } from "../util/config";
import {CohortDataset} from "../containers/HealthcareUsageReport/types/CohortQuery";

export const storyboardApiUrl = (): string => {
    return `${CONFIG.restPrefix}/storyboard/`
}

export const apiFetchTableauTicket = async (): Promise<string> => {
    const url = storyboardApiUrl() + 'tableauTicket'
    const result = await fetch(url, {
        ...(CONFIG.isDev && { credentials: 'include' })
    })
    return result.text()
}

export const apiFetchWorkbooks = async (withPreviewImage: boolean = true): Promise<Workbook[]> => {
    const url = storyboardApiUrl() + `workbooks?withPreviewImage=${withPreviewImage}`
    const result = await fetch(url, {
        ...(CONFIG.isDev && { credentials: 'include' })
    })
    return result.json()
}

export const apiExportWorkbookViewPdf = async (params: {
    workbookId: string,
    viewURLs: string[],
    toName: string,
    toEmail: string
}): Promise<void> => {
    const url = storyboardApiUrl() + `workbook-view/export`
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
        ...(CONFIG.isDev && { credentials: 'include' })
    }).then((response) => {
        if (!response.ok) {
            console.log(response)
            return Promise.reject(`export failed: status: ${response.status}, text: ${response.statusText}`);
        }
    })
}

export const apiSendEmailTemplate = async (storyboard: string, emailAddress: string): Promise<boolean> => {
    const url = storyboardApiUrl() + `workbook-view/sendEmailTemplate?storyboard=${storyboard}&emailAddress=${emailAddress}`
    return fetch(url, {
        ...(CONFIG.isDev && { credentials: 'include' })
    }).then(response => {
        if (response.ok) {
            return true
        } else {
            console.log(response)
            return Promise.reject(`export failed: status: ${response.status}, text: ${response.statusText}`);
        }
    })
}

export const getEmailTemplate = async (storyboardName: string) => {
    const workbook = storyboardName.toUpperCase().split(" ").join("_")
    const url = storyboardApiUrl() + `workbook/${workbook}/template`;
    return fetch(url, {
        ...(CONFIG.isDev && { credentials: 'include' })
    })
        .then(response => {
            if (response.ok) {
                return response.json();
            } else {
                console.error(response)
                return Promise.reject(`getting template failed: status: ${response.status}, text: ${response.statusText}`);
            }
        })
}

export const postEmailTemplate = async (request :
    {workbookName: string, emailRecipients: string[], viewURLs: string[], userInput: { [key: string]: string }} ) => {
    const workbookName = request.workbookName.toUpperCase().split(" ").join("_")
    const url = storyboardApiUrl() +`workbook/${workbookName}/template`;
    return fetch(url, {
        method: "POST",
        headers: { "Content-Type" : "application/json"},
        body: JSON.stringify(request),
        ...(CONFIG.isDev && { credentials: 'include' })
    })
        .then(response => {
            if(!response.ok) {
                return Promise.reject(`export failed: status: ${response.status}, text: ${response.statusText}`);
            }
        })
}

export const apiFetchCohortWorkbook = async (dataset: CohortDataset): Promise<Workbook | undefined> => {
    const url = storyboardApiUrl() + `cohortWorkbook/${dataset}`
    return fetch(url, {
        ...(CONFIG.isDev && { credentials: 'include' })
    })
        .then((response) => {
            if (response.ok) {
                return response.json()
            }
            else {
                console.log(response)
                return Promise.reject(`export failed: status: ${response.status}, text: ${response.statusText}`);
            }
        })
}